export const USERS_DASHBOARD_ENABLE = process.env.VUE_APP__USERS_DASHBOARD_ENABLE === 'true';
export const DEMAND_OVERVIEW_ENABLE = process.env.VUE_APP__DEMAND_OVERVIEW_ENABLE === 'true';
export const PURCHASEORDERS_OVERVIEW_ENABLE = process.env.VUE_APP__PURCHASEORDERS_OVERVIEW_ENABLE === 'true';
